module.exports = __webpack_public_path__ + "img/Reg-SoMe.90ce0271.svg";